import React, {useEffect, useMemo, useState} from 'react'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {dateTimeFormat, KTSVG} from '../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {
  DeleteTemplate,
  getAllTemplate,
  getTemplateList,
} from './CreateScratch/CreateScratchSlices/CreateScratchSlices'
import CreateTemplateModal from './Modal/CreateTemplateModal'
import NodataYet from '../../../Components/NodataYet'
import ReactPaginate from 'react-paginate'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
import {toast} from 'react-toastify'
import { getAllUserDetails } from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { TemplateMobileCard } from './components/TemplateMobileCard'
import './MyTemplateListing.scss'
import { useResponsive } from '../../../hooks/useResponsive'

const MyTemplateListing = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [category, setCategory] = useState<string>('general')

  const [visible, setVisible] = useState<any>(false)
  const [loading, setLoading] = useState<any>(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })
  const templates: any = useSelector(getTemplateList)

  const userDetails = useSelector(getAllUserDetails)
  const userRole = userDetails?.role
  const isAdmin = ['superAdmin', 'accountManager', 'subAdmin', 'sales', 'affiliate'].includes(userRole)
  const { isMobile } = useResponsive()

  useEffect(() => {
    setLoading(true)
    // dispatch(fetchAsyncTemplate())
    let params = {
      ...page,
      category: category === 'general' ? 'general,review' : category
    }

    dispatch(getAllTemplate(params))
    setLoading(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, category])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete template ?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  useEffect(() => {
    if (confirm == true) {
      dispatch(DeleteTemplate(deleteIds))
      setConfirm(false)
    }
  }, [confirm])

  const handleDelete = (template: any) => {
    setOpen(true)
    setDeleteIds(template?._id || template?.id)
  }

  const createNewTemplateModel = useMemo(
    () => <CreateTemplateModal show={visible} handleClose={() => setVisible(false)} />,
    [visible]
  )

  const TemplateCategory = [
    { label: 'SMS + MMS', value: 'general', disabled: false },
    { label: 'Email', value: 'Email', disabled: false },
    { label: 'WhatsApp', value: 'whatsapp', disabled: true },
  ]

  return (
    <>
      {createNewTemplateModel}
      {confirmation}

      <div className={`card`}>
        <div className='card-header border-0 pt-12 px-14'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2'>Templates</span>
            <span className='text-muted fw-bold fs-7'>Ordered by most recent</span>
          </h3>
        </div>

        <div className={`d-flex overflow-auto h-35px px-8 mt-2 justify-content-between border-bottom ${isMobile ? 'template-nav-section-mobile' : ''}`}>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {TemplateCategory.map((key: any, index: any) => {
              const isActive = key?.value === category
              const isDisabled = key?.disabled

              return (
                <li
                  key={index?.toString()}
                  className='nav-item'
                  onClick={() => !isDisabled && setCategory(key?.value)}
                >
                  <div
                    className={`nav-link me-6 text-active-primary fs-4 ${
                      isActive ? 'active' : ''
                    } ${isDisabled ? 'pe-none text-muted opacity-50' : 'cursor-pointer'}`}
                  >
                    {key?.label}
                  </div>
                </li>
              )
            })}
          </ul>
          {AuthenticateUser('create-template') && (
            <div className='card-toolbar'>
              <div className='d-flex card-toolbar'>
                <Link to=''>
                  <a className='btn btn-sm btn-primary' onClick={() => setVisible(true)}>
                    Create new
                  </a>
                </Link>
              </div>
            </div>
          )}
        </div>

        {templates?.items?.length > 0 ? (
          <div className={`card-body py-3 ${isMobile ? 'px-4' : 'px-14'}`}>
            {/* Mobile view: Card layout */}
            {isMobile ? (
              <div className='mobile-templates-list'>
                {loading ? (
                  <div className='text-center py-5'>
                    <Spinner animation='border' variant='primary' />
                  </div>
                ) : (
                  templates?.items?.map((data: any, idx: number) => (
                    <TemplateMobileCard
                      key={idx}
                      template={data}
                      category={category}
                      isAdmin={isAdmin}
                      onDelete={handleDelete}
                      idx={idx}
                    />
                  ))
                )}
              </div>
            ) : (
              /* Desktop view: Table layout */
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-400 text-muted'>
                      <th className='min-w-100px'>ID</th>
                      <th className='w-20px min-w-20px'></th>
                      <th className='min-w-200px max-w-250px'>NAME</th>
                      {category === 'Email' && (
                        <>
                          <th className='min-w-200px'>SUBJECT LINE</th>
                          <th className='min-w-200px'>PREVIEW TEXT</th>
                        </>
                      )}
                      {!isAdmin && category !== 'Email' && (
                        <th className='min-w-250px'>CONTENT</th>
                      )}
                      <th className='ps-4 min-w-125px'>TYPE</th>
                      {isAdmin && (
                        <>
                          <th className='min-w-125px'>SCOPE</th>
                          <th className='min-w-125px'>CATEGORY</th>
                          <th className='min-w-125px'>INDUSTRY</th>
                          <th className='min-w-125px'>AFFILIATE</th>
                        </>
                      )}
                      <th className='min-w-125px'>CREATED</th>
                      <th className='min-w-150px text-end'>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <div className='d-flex justify-content-center align-items-center p-5 w-1000px'>
                        <Spinner animation='border' variant='primary' />
                      </div>
                    ) : (
                      templates?.items?.map((data: any, idx: number) => (
                        <tr key={idx}>
                          <td
                            data-bs-target='license'
                            className='ps-0'
                            style={{
                              marginRight: 0,
                              paddingRight: 0,
                              verticalAlign: 'top',
                            }}
                          >
                            <span
                              className='d-inline-block text-truncate'
                              style={{maxWidth: '250px'}}
                            >
                              <OverlayTrigger
                                placement='top'
                                overlay={<Tooltip id='button-tooltip'>{data?._id || data?.id}</Tooltip>}
                              >
                                <div className='text-mute fs-8'>{data?._id || data?.id}</div>
                              </OverlayTrigger>
                            </span>
                          </td>
                          <td
                            style={{
                              marginLeft: 0,
                              paddingLeft: 0,
                              paddingTop: 5,
                              verticalAlign: 'top',
                            }}
                          >
                            <WSButton
                              onClick={() => {
                                navigator.clipboard.writeText(data?._id)
                                toast.success('Copied!')
                              }}
                              data-action='copy'
                              className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'
                            >
                              <span className='svg-icon svg-icon-2'>
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='24'
                                  height='24'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                >
                                  <path
                                    opacity='0.5'
                                    d='M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z'
                                    fill='currentColor'
                                  />
                                  <path
                                    fill-rule='evenodd'
                                    clipRule='evenodd'
                                    d='M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z'
                                    fill='currentColor'
                                  />
                                </svg>
                              </span>
                            </WSButton>
                          </td>
                          <td
                            style={{
                              verticalAlign: 'top',
                            }}
                          >
                            <span className='text-dark  fw-bolder d-block mb-1 fs-6'>
                              {data?.name || data?.title || '-'}
                            </span>
                            {category !== 'Email' && (
                              <span className='text-bold-400 '>{data?.nameSub}</span>
                            )}
                          </td>
                          {category === 'Email' && (
                            <>
                              <td
                                style={{
                                  verticalAlign: 'top',
                                  whiteSpace: 'pre-wrap',
                                  overflowWrap: 'break-word',
                                  wordBreak: 'break-word',
                                }}
                              >
                                <span className='text-dark fw-400 d-block mb-1 fs-6'>
                                  {data?.subject || data?.emailSubject || data?.subjectLine || '-'}
                                </span>
                              </td>
                              <td
                                style={{
                                  verticalAlign: 'top',
                                  whiteSpace: 'pre-wrap',
                                  overflowWrap: 'break-word',
                                  wordBreak: 'break-word',
                                }}
                              >
                                <span className='text-dark fw-400 d-block mb-1 fs-6'>
                                  {data?.previewText || data?.preview || '-'}
                                </span>
                              </td>
                            </>
                          )}
                          {!isAdmin && category !== 'Email' && (
                            <td
                              style={{
                                verticalAlign: 'top',
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                wordBreak: 'break-word',
                                display: 'inline-block',
                                fontFamily: 'monospace',
                              }}
                            >
                              <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                {data?.message || data?.content}
                              </span>
                            </td>
                          )}
                          <td
                            className='ps-3'
                            style={{
                              verticalAlign: 'top',
                            }}
                          >
                            <span
                              className={
                                data?.type === 'MMS'
                                  ? 'badge badge-light-success green_text_badge badge-square p-4 w-50px py-5'
                                  : 'badge badge-light-info fs-7 blue_text_badge badge-square p-4 w-50px py-5'
                              }
                            >
                              {data?.type !== 'TEXT' ? data?.type : 'EMAIL'}
                            </span>
                          </td>
                          {isAdmin && (
                            <>
                              <td
                                style={{
                                  verticalAlign: 'top',
                                }}
                              >
                                <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                  {data?.scope || '-'}
                                </span>
                              </td>
                              <td
                                style={{
                                  verticalAlign: 'top',
                                }}
                              >
                                <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                  {data?.category || '-'}
                                </span>
                              </td>
                              <td
                                style={{
                                  verticalAlign: 'top',
                                }}
                              >
                                <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                  {data?.industry || '-'}
                                </span>
                              </td>
                              <td
                                style={{
                                  verticalAlign: 'top',
                                }}
                              >
                                <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                  {data?.affiliate || '-'}
                                </span>
                              </td>
                            </>
                          )}
                          <td
                            style={{
                              verticalAlign: 'top',
                            }}
                          >
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {dateTimeFormat(data?.createdAt, 'MMM DD YYYY')}
                            </span>
                          </td>
                          <td
                            className='ms-2 text-end'
                            style={{
                              verticalAlign: 'top',
                            }}
                          >
                            {AuthenticateUser('edit-template') && (
                              <button
                                className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2'
                                onClick={() =>
                                  navigate('/New-Template', {
                                    state: {
                                      id: idx,
                                      data: data,
                                      category: category, // Pass category to help detect Email template
                                    },
                                  })
                                }
                              >
                                <KTSVG
                                  path='/media/icons/duotune/art/art005.svg'
                                  className='svg-icon-2'
                                />
                              </button>
                            )}
                            {AuthenticateUser('delete-template') && (
                              <button
                                className='btn btn-sm btn-icon trash btn-light btn-active-light-primary'
                                onClick={() => handleDelete(data)}
                              >
                                <KTSVG
                                  className='svg-icon-2'
                                  path='/media/icons/duotune/art/trush.svg'
                                />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <div className='abcd '>
              <select
                value={page?.size}
                className='SelectSize'
                onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={templates?.total}>ALl</option>
              </select>
              <ReactPaginate
                previousLabel='<'
                nextLabel='>'
                pageCount={templates?.totalPages}
                onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                containerClassName={'pagiantion'}
                previousLinkClassName={'pagination__link'}
                nextLinkClassName={'pagination__link'}
                disabledClassName={'pagination__link--disabled'}
                activeClassName={'pagination__link--active'}
              />
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default MyTemplateListing
